"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponse = exports.createRequest = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const createRequest = (request) => {
    const { id, method, url, body, bodyType, headers, responseType, params } = request;
    const urlWithParams = (0, web_ui_framework_1.buildQueryString)(url, params);
    return {
        id,
        data: {
            url: urlWithParams,
            method,
            body,
            bodyType,
            headers,
            responseType,
        },
    };
};
exports.createRequest = createRequest;
const createResponse = (response) => {
    const { id, data: { body, http_status, headers }, } = response;
    return {
        id,
        body: body ?? '',
        status: http_status,
        statusText: http_status >= 200 && 300 > http_status ? 'ok' : 'ko',
        headers,
        ok: http_status >= 200 && http_status < 300,
    };
};
exports.createResponse = createResponse;
//# sourceMappingURL=utils.js.map